/**
 * Human-readable grant state. Expired grants stay visible in the UI rather than disappearing —
 * a client silently losing a capability with no trace of why is exactly the confusion this
 * feature exists to remove.
 */
export function describeGrantState(grant) {
    switch (grant.state) {
        case "expired":
            return `expired ${formatDate(grant.expiresAt)}`
        case "pending":
            return `starts ${formatDate(grant.startsAt)}`
        case "disabled":
            return "disabled"
        case "invalidWindow":
            return "invalid dates"
        default:
            return grant.expiresAt ? `active until ${formatDate(grant.expiresAt)}` : "active"
    }
}

export function isGrantInactive(grant) {
    return grant.state !== "active"
}

/**
 * Just the state, with no date — for use beside its own Starts/Ends columns, where
 * describeGrantState would repeat what the row already shows.
 */
export function shortGrantState(grant) {
    switch (grant.state) {
        case "expired":
            return "expired"
        case "pending":
            return "not started"
        case "disabled":
            return "disabled"
        case "invalidWindow":
            return "invalid dates"
        default:
            return "active"
    }
}

/**
 * @returns {string} a locale date, or "" when there is no boundary — callers choose their own
 * wording for that ("immediately", "no expiry"), which reads better than a shared dash.
 */
export function formatGrantDate(value) {
    if (!value) return ""
    return formatDate(value)
}

function formatDate(value) {
    if (!value) return "—"
    const parsed = new Date(value)
    return Number.isNaN(parsed.getTime()) ? String(value) : parsed.toLocaleDateString()
}
